import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUSES } from '../lib/data';
export function Bonuses() {
  return <section className="py-8" data-id="element-28" data-mp="pio8klwnr28j">
      <div className="mb-5 flex flex-col items-center px-4 text-center" data-id="element-29" data-mp="pm2a5rxhz7ex">
        <span className="inline-flex items-center gap-2 rounded-full bg-hockey-pink/15 px-4 py-1.5 text-sm font-bold text-hockey-pink" data-id="element-30" data-mp="aua4k7ni97qe">
          <GiftIcon className="h-4 w-4" data-id="element-31" data-mp="frtmbhjew2n3" /> GRATIS solo por hoy
        </span>
        <h2 className="mt-3 font-display text-2xl leading-tight text-white" data-id="element-32" data-mp="1t3pm30i84z9">
          Además, llévate estos bonos sin cargo
        </h2>
        <p className="mt-2 text-sm text-white/60" data-id="element-33" data-mp="3o1v48bynxmnk">9 recursos extra listos para aplicar, incluidos hoy.</p>
      </div>

      <div className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2" aria-label="Carrusel de bonos incluidos" aria-roledescription="carrusel" data-id="element-34" data-mp="3szwoh07trs0m">
        {BONUSES.map(bonus => <article key={bonus.title} className="w-[78vw] max-w-[300px] shrink-0 snap-center overflow-hidden rounded-2xl border border-white/10 bg-hockey-card shadow-xl" data-id="element-35" data-mp="1r8jwtcuvbgmi">
            {bonus.preview ? <img src={bonus.preview} alt={`Vista previa de ${bonus.title}`} className="aspect-[4/3] w-full object-cover object-top" loading="lazy" data-id="element-36" data-mp="3r6i6exp1jf90" /> : <div className="flex aspect-[4/3] items-center justify-center bg-hockey-greendark/60 text-6xl" aria-hidden="true" data-id="element-37" data-mp="2zgdgkjiii00e">
                {bonus.emoji}
              </div>}

            <div className="p-4" data-id="element-38" data-mp="38h1t19s9bsb6">
              <div className="flex items-start justify-between gap-3" data-id="element-39" data-mp="38e5x1qzyzdpd">
                <h3 className="text-[15px] font-extrabold leading-snug text-white" data-id="element-40" data-mp="33fm6teecffr7">{bonus.title}</h3>
                <span className="shrink-0 rounded-full bg-emerald-500/15 px-2 py-1 text-[10px] font-extrabold text-emerald-400" data-id="element-41" data-mp="nogf353yzbsg">
                  GRATIS
                </span>
              </div>
              <p className="mt-3 text-[13px] leading-snug text-white/70" data-id="element-42" data-mp="3ciemd4oadwzm">{bonus.desc}</p>
            </div>
          </article>)}
      </div>

      <p className="mt-3 text-center text-[11px] text-white/40" data-id="element-43" data-mp="3ljl39euul9te">← Desliza para ver los 9 bonos incluidos →</p>
    </section>;
}